// mantine
import { ActionIcon, Button, Menu } from '@mantine/core';
// icons
import { Trash2, Ellipsis } from 'lucide-react';
// components
import SearchInput from '@/pages/AKB/components/Toolbar/components/SearchInput';
import ImportAKBButton from '@/pages/AKB/components/Toolbar/components/ImportAKBButton';
import ImportTextButton from '@/pages/AKB/components/Toolbar/components/ImportTextButton';
import ExportAKBButton from '@/pages/AKB/components/Toolbar/components/ExportAKBButton';
// utils
import useAKBStore from '@/pages/AKB/AKB.store.ts';

interface ToolbarProps {
    hasSelectedItems: boolean;
    hasTopics: boolean;
    onTopicsDelete: () => void;
    onAKBDelete: () => void;
    searchTerm?: string;
    onSearchChange: (searchTerm: string) => void;
}

const Toolbar = ({
    hasSelectedItems,
    hasTopics,
    onTopicsDelete,
    onAKBDelete,
    searchTerm,
    onSearchChange
}: ToolbarProps) => {
    const storedPersona = useAKBStore((state) => state.persona);
    const personaId = storedPersona?.id ?? '';

    return (
        <div className="flex items-center gap-4 pb-4 pt-4">
            <SearchInput
                className="mr-auto w-1/4"
                personaId={personaId}
                searchTerm={searchTerm}
                onChange={onSearchChange}
            />

            <Button
                color="red"
                disabled={!hasSelectedItems}
                leftSection={<Trash2 />}
                variant="transparent"
                onClick={onTopicsDelete}
            >
                Delete Selected
            </Button>
            <ImportTextButton personaId={personaId} />

            <ImportAKBButton isDisabled={!personaId} personaId={personaId} />
            <ExportAKBButton isDisabled={!hasTopics} persona={storedPersona} />

            <Menu shadow="md" width={200}>
                <Menu.Target>
                    <ActionIcon
                        className="ml-8"
                        size="xs"
                        variant="transparent"
                    >
                        <Ellipsis />
                    </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        className="text-red-6"
                        disabled={!hasTopics}
                        leftSection={<Trash2 />}
                        onClick={onAKBDelete}
                    >
                        Delete AKB
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </div>
    );
};

export default Toolbar;
